import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { CurrentUser } from "../../SharedComponents/CurrentUser/CurrentUser";
import "./AdminHeader.css";

export const AdminHeader = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div
      className="AdminHeader"
      style={
        location.pathname.includes("profile")
          ? { borderColor: "rgba(216, 216, 216, 0.3)" }
          : { borderColor: "#d8d8d8" }
      }
    >
      <div className="AdminHeader__title">
        <div
          className="AdminHeader__title-text"
          style={
            location.pathname.includes("profile")
              ? { color: "#ffffff" }
              : { color: "#848c96" }
          }
        >
          <div className="AdminHeader__title-text--bold">eflow</div>
          <div className="AdminHeader__title-text--normal">
            {t("generic.adminConsole")}
          </div>
        </div>
      </div>
      <div className="AdminHeader__user">
        <CurrentUser />
      </div>
    </div>
  );
};
